import React from 'react';

export const TooltipPreview = ({ component, onClick, isSelected }) => {
  const { commonAttrs, specificAttrs } = component;
  const { text, position } = specificAttrs || {};
  
  const containerStyle = {
    padding: `${commonAttrs?.paddingTop || 16}px ${commonAttrs?.paddingRight || 16}px ${commonAttrs?.paddingBottom || 16}px ${commonAttrs?.paddingLeft || 16}px`,
    margin: `${commonAttrs?.marginTop || 8}px ${commonAttrs?.marginRight || 0}px ${commonAttrs?.marginBottom || 8}px ${commonAttrs?.marginLeft || 0}px`,
    width: commonAttrs?.width === 'auto' ? 'auto' : `${commonAttrs?.width || 100}%`,
    cursor: onClick ? 'pointer' : 'default',
    border: isSelected ? '2px solid #3B82F6' : '2px solid transparent',
    borderRadius: '4px'
  };
  
  return (
    <div style={containerStyle} onClick={onClick}>
      <div style={{ position: 'relative', display: 'inline-block' }}>
      <button style={{
        padding: '8px 16px',
        background: '#3B82F6',
        color: '#FFFFFF',
        border: 'none',
        borderRadius: '6px',
        fontSize: '14px',
        cursor: 'pointer'
      }}>
        Hover me
      </button>
      <div style={{
        position: 'absolute',
        [position === 'bottom' ? 'top' : 'bottom']: '100%',
        left: '50%',
        transform: 'translateX(-50%)',
        marginBottom: position === 'top' ? '8px' : '0',
        marginTop: position === 'bottom' ? '8px' : '0',
        padding: '6px 10px',
        background: '#1F2937',
        color: '#FFFFFF',
        borderRadius: '6px',
        fontSize: '12px',
        whiteSpace: 'nowrap',
        pointerEvents: 'none'
      }}>
        {text || 'Tooltip text'}
      </div>
      </div>
    </div>
  );
};
